import HRBlockSidebarFooterImage from 'src/assets/hr-block-sidebar-foot.png';
import HRBlockSidebarHeaderImage from 'src/assets/hr-block-sidebar-header.png';

export function HRBlockSidebar() {
  return (
    <div className="fixed bottom-0 left-0 top-0 z-20 flex min-h-dvh max-w-space-244 flex-col justify-between bg-accent-white">
      <img src={HRBlockSidebarHeaderImage} alt="HR Block Sidebar Header" />
      <img src={HRBlockSidebarFooterImage} alt="HR Block Sidebar Footer" />
    </div>
  );
}
